export function AiAgentChats() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="82" height="52" viewBox="0 0 82 52" fill="none">
      <rect x="17.0996" width="64" height="28" rx="6" fill="#E9E9E9" />
      <rect x="44.0996" y="9" width="20" height="4" rx="2" fill="white" />
      <rect x="24.873" y="14.8926" width="39" height="4" rx="2" fill="white" />
      <ellipse cx="72.7181" cy="13.6429" rx="4.61849" ry="4.64287" fill="white" />
      <rect x="0.902344" y="24" width="64" height="28" rx="6" fill="#F4F4F4" />
      <rect x="20.5664" y="33.0723" width="20" height="4" rx="2" fill="white" />
      <rect x="20.5664" y="39.0723" width="39" height="4" rx="2" fill="white" />
      <ellipse cx="11.6185" cy="37.6429" rx="4.61849" ry="4.64287" fill="white" />
    </svg>
  );
}
